// extracted by css-extract-rspack-plugin
export default {"breadcrumbs":"DataStudioBreadcrumbs-module__breadcrumbs___p4lU9"};